import React from "react";

class TopUsers extends React.Component {
    render() {
        return (
            <div className="container-fluid">
                <div className="animated">
                    Top Users
                </div>
            </div>
        );
    }
}

export default TopUsers;



// WEBPACK FOOTER //
// ./src/views/pages/top-users/index.js